import React, { Component } from 'react';
import { Text, ScrollView } from 'react-native'
import { connect } from 'react-redux'
import { CheckElement, CheckIcon, CostumTopbar } from '../_Common'
class DetailAutoTest extends Component {
    render() {
        return (
            <>
                <CostumTopbar title="Detail de test" goBack={this.props.history.goBack} />
                <ScrollView
                    showsVerticalScrollIndicator={false}
                >
                    <CheckElement Icon={<CheckIcon width="110" height="110" />}>
                        <Text style={{ fontSize: 20, fontWeight: "700", textAlign: "center" }}>L' évaluation est terminée, veuillez vous référer à votre autre test 😀</Text>
                    </CheckElement>
                </ScrollView>
            </>
        )
    }
}
function mapState(state) {
    return {}
}
const actionCreators = {
};

const connectedClass = connect(mapState, actionCreators)(DetailAutoTest);
export { connectedClass as DetailAutoTest };